import React from "react";
import { StyleSheet } from "react-native";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { Drawer } from "expo-router/drawer";

import SettingsDrawer from "@/screens/Settings/SettingsDrawer";
import { useSession } from "@/context/auth/useSession";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import SettingsHeader from "@/screens/Settings/Components/SettingsHeader";

export default function DrawerLayout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <GestureHandlerRootView>
      <Drawer
        drawerContent={() => <SettingsDrawer session={session} />}
        screenOptions={{
          drawerStyle: styles.drawer,
          drawerType: "front",
          swipeEnabled: false,
          header: ({ options }) => (
            <SettingsHeader title={options.title ?? "Settings"} />
          ),
        }}
      >
        <Drawer.Screen name="home" options={{ headerShown: false }} />
        <Drawer.Screen
          name="subscription"
          options={{ title: "Subscription" }}
        />
        <Drawer.Screen name="app-update" options={{ title: "App Update" }} />
        <Drawer.Screen
          name="block-users"
          options={{ title: "Blocked Users" }}
        />
        <Drawer.Screen
          name="cache-management"
          options={{ title: "Cache Management" }}
        />
        <Drawer.Screen
          name="delete-account"
          options={{ title: "My Account" }}
        />
        <Drawer.Screen name="diagnostics" options={{ title: "Diagnostics" }} />
        <Drawer.Screen name="logout" options={{ title: "Logout" }} />
        <Drawer.Screen
          name="push-notifications"
          options={{ title: "Push Notifications" }}
        />
        <Drawer.Screen
          name="update-password"
          options={{ title: "Update Password" }}
        />
      </Drawer>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  drawer: {
    width: "75%",
  },
});
